export default __webpack_public_path__ + "static/media/IconDesc_Mycelia.64.9b91b986.png";